import { matchPath } from 'react-router';

import { ROUTE_DRAFT_VIEW } from 'modules/draft/routes/constants';

const matcher = (pathname, route) => matchPath(pathname, route) !== null;

export const isViewDraftRoute = (location) => matcher(location.pathname, ROUTE_DRAFT_VIEW);
